import axios  from 'axios'
import {Message, MessageBox, Notification} from "element-ui";
//设置asxios对象请求头的content-type值
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

//创建axios实例
const service = axios.create({
    //axios中配置有baseURL选项，请求URL公共部分
    baseURL:process.env.VUE_APP_BASE_API,
    // baseURL:'http://api.diantongtianxia.com/sjxy-oa',
    // baseURL:'http://api.diantongtianxia.com/jdkj-szcp',

    //超时
    timeout:10000
})

// 添加请求拦截器
service.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    return config;
}, error => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(res => {
        return res.data
    },
    error => {
        console.log('err' + error)
        let { message } = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        }
        else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        }
        else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    });

export default service
